import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 早起懒加载方法
const list = r => require.ensure([], () => r(require('../pages/list.vue')), 'list')
const detail = r => require.ensure([], () => r(require('../pages/detail.vue')), 'detail')

export default new Router({
    scrollBehavior(to, from, savedPosition) {
        // keep-alive 返回缓存页面后记录浏览位置
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition;
        }
        // 异步滚动操作
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    x: 0,
                    y: 1
                });
            }, 0);
        });
    },
    mode: 'history',
    routes: [{
            path: '/',
            component: list,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/detail',
            component: detail
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js